import React from 'react'
import Loader from 'react-loader-spinner';
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";

class LoaderMessage extends React.Component {
    constructor(props) {
        super(props);
    }

    state = {
    };

    componentDidMount(){
    }

    componentWillReceiveProps(nextProps) {
    }


    componentWillMount() {
    }

    alertConfirm = () => {
    };

    render() {
        return (
            <div>
                {
                    this.props.showLoader?
                        <div className='loader-puff'>
                            <Loader type="ThreeDots" color="#00BFFF" height={80} width={80} />
                            {
                                this.props.loaderMessage && this.props.loaderMessage !== '' ?
                                    <p>{this.props.loaderMessage}</p>
                                    :
                                    null
                            }
                        </div>
                        :
                        null
                }
            </div>
        )
    }
}

const mapStateToProps = ({ loader }) => ({
    loaderMessage: loader.loaderMessage,
    showLoader: loader.showLoader
});

export default withRouter(connect(
    mapStateToProps
)(LoaderMessage))